export function getValidity(input, customError = false) {
    const validity = {
        valid: customError ? false : input?.validity.valid,
        customError,
        badInput: input?.validity.badInput,
        patternMismatch: input?.validity.patternMismatch,
        rangeOverflow: input?.validity.rangeOverflow,
        rangeUnderflow: input?.validity.rangeUnderflow,
        stepMismatch: input?.validity.stepMismatch,
        tooLong: input?.validity.tooLong,
        tooShort: input?.validity.tooShort,
        typeMismatch: input?.validity.typeMismatch,
        valueMissing: input?.validity.valueMissing
    };
    return validity;
}
//# sourceMappingURL=validation.js.map
